(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ev-qty]');
    if (q) {
      var row = q.closest('.ev-citem');
      var key = q.getAttribute('data-key');
      var valEl = row ? row.querySelector('.ev-qty__val') : null;
      var cur = valEl ? (parseInt(valEl.textContent.trim(), 10) || 0) : 0;
      var next = q.getAttribute('data-ev-qty') === 'inc' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      q.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: next }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
      return;
    }
    var ap = e.target.closest('[data-ev-apply-discount]');
    if (ap) {
      var input = document.getElementById('ev-discount-code');
      var code = input ? (input.value || '').trim() : '';
      if (code) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ev-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.href;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ev-filter-toggle]');
    if (!btn) return;
    var root = btn.closest('.ev-coll');
    if (root) root.classList.toggle('ev-filters-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bars = document.querySelectorAll('.zapply-announce');
    bars.forEach(function(bar) {
      var barId = bar.id;
      var storageKey = 'zapply_announce_dismissed_' + barId;

      // Check if dismissed
      if (localStorage.getItem(storageKey) === 'true') {
        bar.style.display = 'none';
        return;
      }

      // Show bar
      bar.style.display = 'block';

      // Close button
      var closeBtn = bar.querySelector('.zapply-announce__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          bar.style.display = 'none';
          localStorage.setItem(storageKey, 'true');
        });
      }

      // Auto-rotate messages
      var track = bar.querySelector('[id$="-track"]');
      if (!track) return;

      var messages = track.querySelectorAll('.zapply-announce__message');
      if (messages.length <= 1) return;

      var currentIndex = 0;
      var totalMessages = messages.length;

      setInterval(function() {
        currentIndex = (currentIndex + 1) % totalMessages;
        track.style.transform = 'translateY(-' + (currentIndex * 40) + 'px)';
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
      const btn = item.querySelector('.faq-question');
      btn.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        // Close all
        faqItems.forEach(i => i.classList.remove('active'));
        // Open clicked if it wasn't open
        if (!isActive) item.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var forms = document.querySelectorAll('[id^="newsletter-form-"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var sectionId = form.id.replace('newsletter-form-', '');
        var successEl = document.getElementById('newsletter-success-' + sectionId);
        var inputGroup = form.querySelector('.zapply-newsletter__input-group');

        // Let the form submit normally, but also show success feedback
        // For a better UX, we can handle via AJAX:
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput.value;
        if (!email) return;

        var submitBtn = form.querySelector('.zapply-newsletter__btn');
        var originalHTML = submitBtn.innerHTML;
        submitBtn.innerHTML = 'Subscribing...';
        submitBtn.disabled = true;

        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter&contact%5Bemail%5D=' + encodeURIComponent(email)
        })
        .then(function() {
          inputGroup.style.display = 'none';
          successEl.style.display = 'flex';
        })
        .catch(function() {
          // Still show success since Shopify might redirect
          inputGroup.style.display = 'none';
          successEl.style.display = 'flex';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-results"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nums = document.querySelectorAll('.pstat__num');
    if (!nums.length) return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var target = parseInt(el.dataset.target, 10) || 0;
      if (prefersReduced) { el.textContent = target + '%'; return; }
      var start = null;
      var dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target) + '%';
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      nums.forEach(function(n){ n.textContent = n.dataset.target + '%'; });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { countUp(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function(n){ obs.observe(n); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mainBtn = document.getElementById('AddToCart');
    const stickyBar = document.getElementById('StickyATC');
    
    if (!mainBtn || !stickyBar) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          // Button has scrolled up past the viewport
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    
    observer.observe(mainBtn);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-track-order"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('TrackButton');
    const input = document.getElementById('TrackingNumber');
    const results = document.getElementById('TrackingResults');
    const error = document.getElementById('TrackingError');
    const display = document.querySelector('#TrackingDisplay strong');
    if (btn && input) {
      btn.addEventListener('click', () => {
        const val = input.value.trim();
        results.style.display = 'none';
        error.style.display = 'none';
        if (val.length < 5) { error.style.display = 'block'; return; }
        display.textContent = val;
        results.style.display = 'block';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ev-menu-toggle]');
      if (toggle) { e.preventDefault(); document.documentElement.classList.toggle('ev-menu-open'); return; }
      var panel = e.target.closest('.ev-mobile-menu__panel');
      var closeBtn = e.target.closest('button[data-ev-menu-close], [data-ev-menu-close].material-symbols-outlined');
      var overlay = e.target.closest('.ev-mobile-menu');
      if (closeBtn) { document.documentElement.classList.remove('ev-menu-open'); return; }
      if (overlay && !panel) { document.documentElement.classList.remove('ev-menu-open'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.documentElement.classList.remove('ev-menu-open');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
